



// import React, { useContext } from "react";
// import { toast, ToastContainer } from "react-toastify";
// import { BsWhatsapp } from "react-icons/bs";
// import { FaTelegramPlane, FaCrown, FaUsers } from "react-icons/fa";
// import { FiCopy, FiCheckCircle } from "react-icons/fi";
// import { GiCoins } from "react-icons/gi";
// import { LanguageContext } from "../Components/LanguageContext";
// import "react-toastify/dist/ReactToastify.css";
// // import "./Refer.css";

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   if (!user) return null;

//   const copyCode = () => {
//     navigator.clipboard.writeText(user.referral_code);
//     toast.success("Referral Code Copied!", {
//       position: "top-center",
//       autoClose: 1500,
//       hideProgressBar: true,
//       closeOnClick: true,
//       pauseOnHover: false,
//       draggable: true,
//       theme: "light",
//     });
//   };

//   const copyLink = () => {
//     const link = `https://mkadda.com/login/${user.referral_code}`;
//     navigator.clipboard.writeText(link);
//     toast.success("Referral Link Copied!", {
//       position: "bottom-center",
//       autoClose: 1500,
//       hideProgressBar: true,
//       closeOnClick: true,
//       pauseOnHover: false,
//       draggable: true,
//       theme: "light",
//     });
//   };

//   const shareText = `Hi Friends, Play MKADDA Ludo and earn 10000 daily. Download Indian App MKADDA
// बम्पर धमाका ऑफर 💸💸💸 💥💥💥💥💥💥
// दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा

// MKADDA पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
// 100% भरोसेमंद प्लेटफॉर्म । 24 hours support https://mkadda.com/login/${user.referral_code}

// Your ReferralCode is -${user.referral_code}.`;

//   return (
//     <div className="refer-wrapper leftContainer mt-5 pt-5">
//       <ToastContainer limit={2} />

//       {/* Ambient background blur elements */}
//       <div className="refer-ambient-glow glow-1"></div>
//       <div className="refer-ambient-glow glow-2"></div>

//       <div className="refer-container mb-5">
//         {/* Top VIP Badge Banner */}
//         <div className="refer-header">
//           <div className="vip-badge-pill">
//             <FaCrown className="crown-icon" />
//             <span>BAMPER DHAMAKA </span>
//           </div>
//           <h1 className="refer-title">
//             Invite & Earn <span className="highlight-text"> Cash</span>
//           </h1>
//           <p className="refer-subtitle">
//             Share with friends & get up to{" "}
//             <strong className="commission-text">3% Commission</strong> on every victory!
//           </p>
//         </div>

//         {/* Stats Grid */}
//         <div className="stats-grid">
//           <div className="stat-card network-card">
//             <div className="stat-icon-wrapper blue">
//               <FaUsers />
//             </div>
//             <div className="stat-info">
//               <span className="stat-label">TOTAL REFERAL</span>
//               <h3 className="stat-value">{user.referral_user?.length || 0}</h3>
//             </div>
//           </div>

//           <div className="stat-card earnings-card">
//             <div className="stat-icon-wrapper gold">
//               <GiCoins />
//             </div>
//             <div className="stat-info">
//               <span className="stat-label">TOTAL EARNED</span>
//               <h3 className="stat-value gold">₹{user.referral_earning || 0}</h3>
//             </div>
//           </div>
//         </div>

//         {/* Main Referral Action Box */}
//         <div className="referral-box">
//           <div className="referral-box-header">
//             <span className="box-title">YOUR  CODE</span>
//             <span className="perk-tag">Instant Payouts</span>
//           </div>

//           <div className="code-input-group">
//             <div className="code-display">
//               <span className="code-text">{user.referral_code}</span>
//             </div>
//             <button className="copy-code-btn" onClick={copyCode}>
//               <FiCopy className="btn-icon" />
//               <span>COPY CODE</span>
//             </button>
//           </div>

       

//           {/* Social Sharing Actions Grid */}
//           <div className="social-actions-section">
//             <p className="social-heading">Share directly via</p>
//             <div className="social-grid">
//               <a
//                 href={`whatsapp://send?text=${encodeURIComponent(shareText)}`}
//                 className="social-btn whatsapp-btn"
//               >
//                 <div className="social-icon-bg">
//                   <BsWhatsapp />
//                 </div>
//                 <span className="social-btn-label">WhatsApp</span>
//               </a>

//               <a
//                 href={`https://t.me/share/url?url=https://mkadda.com/login/${user.referral_code}&text=${encodeURIComponent(shareText)}`}
//                 className="social-btn telegram-btn"
//               >
//                 <div className="social-icon-bg">
//                   <FaTelegramPlane />
//                 </div>
//                 <span className="social-btn-label">Telegram</span>
//               </a>

//               <button className="social-btn copylink-btn" onClick={copyLink}>
//                 <div className="social-icon-bg">
//                   <FiCopy />
//                 </div>
//                 <span className="social-btn-label">Copy Link</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Refer;


import React, { useContext } from "react";
import { toast, ToastContainer } from "react-toastify";
import { BsWhatsapp } from "react-icons/bs";
import { FaTelegramPlane, FaCrown, FaUsers, FaShareAlt } from "react-icons/fa";
import { FiCopy, FiShare2, FiGift, FiAward, FiZap } from "react-icons/fi";
import { GiCoins } from "react-icons/gi";
import { LanguageContext } from "../Components/LanguageContext";
import Rightcontainer from "../Components/Rightcontainer";
import "react-toastify/dist/ReactToastify.css";
// import "./Refer.css";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);

  if (!user) return null;

  const copyCode = () => {
    navigator.clipboard.writeText(user.referral_code);
    toast.success("Referral Code Copied!", {
      position: "top-center",
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });
  };

  const copyLink = () => {
    const link = `https://mkadda.com/login/${user.referral_code}`;
    navigator.clipboard.writeText(link);
    toast.success("Referral Link Copied!", {
      position: "bottom-center",
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });
  };

  const shareText = `Hi Friends, Play MKADDA Ludo and earn 10000 daily. Download Indian App MKADDA
बम्पर धमाका ऑफर 💸💸💸 💥💥💥💥💥💥
दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा

MKADDA पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
100% भरोसेमंद प्लेटफॉर्म । 24 hours support https://mkadda.com/login/${user.referral_code}

Your ReferralCode is -${user.referral_code}.`;

  return (
    <div className="sa-luxury-wallet-wrapper leftContainer mt-4 pt-4">
      {/* Dynamic Ambient Background Illumination */}
      <div className="ambient-glow glow-one"></div>
      <div className="ambient-glow glow-two"></div>
      <div className="ambient-glow glow-three"></div>

      <div className="sa-luxury-layout-grid refer-layout-extended">
        <ToastContainer limit={2} />

        {/* Master Referral Hero Container */}
        <div className="sa-wallet-container refer-master-box">
          
          {/* Top Promotional Banner */}
          <div className="refer-hero-banner">
            <div className="hero-glow-effect"></div>
            <div className="banner-badge-wrapper">
              <span className="live-pulse-dot"></span>
              <FaCrown className="banner-crown" />
              <span>MEGA REFERRAL PROGRAM</span>
            </div>
            <h1>Invite Friends & Unlock <span className="highlight-gradient">Infinite Earnings</span></h1>
            {/* <p>Share your exclusive link and earn up to <strong>3% commission</strong> on every single match your network wins!</p> */}
          </div>

          {/* Key Performance Metric Cards */}
          <div className="refer-metrics-row">
            <div className="metric-box network-metric">
              <div className="metric-icon-wrap blue-glow">
                <FaUsers size={20} />
              </div>
              <div className="metric-details">
                <span className="metric-title">TOTAL REFERRALS</span>
                <h3 className="metric-count">{user.referral_user?.length || 0}</h3>
              </div>
              <div className="metric-trend">
                <FiZap size={14} /> Active Network
              </div>
            </div>

            <div className="metric-box earnings-metric">
              <div className="metric-icon-wrap gold-glow">
                <GiCoins size={22} />
              </div>
              <div className="metric-details">
                <span className="metric-title">TOTAL EARNED</span>
                <h3 className="metric-count gold-text">₹{user.referral_earning || 0}</h3>
              </div>
              <div className="metric-trend success">
                <FiAward size={14} /> Instant Payouts
              </div>
            </div>
          </div>

          {/* Interactive Code Hub */}
          <div className="code-hub-card">
            <div className="hub-header-flex">
              <div className="hub-title-group">
                <FiGift size={18} className="hub-icon" />
                <span>Your Exclusive Referral Code</span>
              </div>
              <span className="status-pill-green">Verified & Ready</span>
            </div>

            <div className="code-action-row">
              <div className="code-field-box">
                <span className="code-string">{user.referral_code}</span>
              </div>
              <button className="sa-btn sa-btn-add code-copy-trigger" onClick={copyCode}>
                <FiCopy size={16} />
                <span>Copy Code</span>
              </button>
            </div>
          </div>

          {/* Multi-Channel Instant Share Matrix */}
          <div className="social-sharing-hub mb-5">
            <div className="sharing-header-label">
              <FaShareAlt size={14} />
              <span>Instant Share via Social Platforms</span>
            </div>
            
            <div className="social-grid-modern">
              <a
                href={`whatsapp://send?text=${encodeURIComponent(shareText)}`}
                className="social-card-item whatsapp-card"
              >
                <div className="social-icon-circle wa-bg">
                  <BsWhatsapp size={20} />
                </div>
                <div className="social-text-info">
                  <strong>WhatsApp</strong>
                  <span>Instant Broadcast</span>
                </div>
              </a>

              <a
                href={`https://t.me/share/url?url=https://mkadda.com/login/${user.referral_code}&text=${encodeURIComponent(shareText)}`}
                className="social-card-item telegram-card"
              >
                <div className="social-icon-circle tg-bg">
                  <FaTelegramPlane size={20} />
                </div>
                <div className="social-text-info">
                  <strong>Telegram</strong>
                  <span>Group Sharing</span>
                </div>
              </a>

              <button className="social-card-item link-card-btn" onClick={copyLink}>
                <div className="social-icon-circle link-bg">
                  <FiShare2 size={20} />
                </div>
                <div className="social-text-info">
                  <strong>Copy Link</strong>
                  <span>Direct URL</span>
                </div>
              </button>
            </div>
          </div>

        </div>

        {/* Right Container Sidebar (Desktop View) */}
        <div className="rightContainer mobile-hide">
          <Rightcontainer />
        </div>
      </div>
    </div>
  );
};

export default Refer;